<template>
  <div>


    <div id="card-element">
      <!-- Elements will create input elements here -->
    </div>
    <div class="text-red-600 text-sm mt-2 mb-2">{{ cardError }}</div>

    <!-- We'll put the error messages in this element -->

    <div class ="inline-flex float-right md:w-48">
      <button-loading
          @click="submit"
          :loading="isSubmitting"
          buttonlabel="Update Card Details"
          buttonlabelloading="Processing..."

      ></button-loading>
    </div>
  </div>
</template>

<script>

import {loadStripe} from "@stripe/stripe-js";

export default {
  components: {},
  props: {
    stripe_pk: {
      type: String,
      required: true
    },
    stripe_locale: {
      type: String,
      required: true
    },
    endpoint: {
      type: String,
      required: true
    },
    secret_intent: {
      type: String,
      required: true
    },
  },
  data: function () {
    return {
      card: null,
      validated: null,
      isSubmitting: false,
      cardSavedSuccessfully: false,
      cardError: '',
    }
  },
  methods: {

    submit: function () {

      let self = this;
      if (this.isSubmitting) {
        return false;
      }

      this.isSubmitting = true;
      this
          .createPaymentMethod()
          .then(paymentMethod => this.returnPaymentMethod(paymentMethod))
          .then(function (data) {
            self.cardSavedSuccessfully = true;
            window.location.href = data.location;
          })
          .catch(function (error) {
            console.log(error);
            self.validated = false;
            self.cardError = error;
          })
          //re-enable our submit button
          .then(function () {

            self.isSubmitting = false; //move this to a better place
          });
    },

    /**
     * Sends card details to stripe to get a payment method back
     * @returns {Promise<{paymentMethod: *}>}
     */
    createPaymentMethod() {
      return this
          .stripe
          .createPaymentMethod('card', this.card)
          .then((result) => {
            if (result.error) {
              throw new Error(result.error.message);
            }

            console.log(result);

            return result.paymentMethod;
          });
    },

    /**
     * Sends our payment method back to our service
     * @param paymentMethod
     * @returns {Promise<AxiosResponse<any>>}
     */
    returnPaymentMethod(paymentMethod) {

      return window.axios.post(this.endpoint, {
        payment_method: paymentMethod.id
      })
          .then(response => {
            return response.data;
          });
    },


  },
  async mounted() {

    this.stripe = await loadStripe(
        this.stripe_pk,
        {
          locale: this.stripe_locale
        }
    );

    this.elements = this.stripe.elements();

    let style = {
      base: {
      },
    };

    let eventListener = (event) => {

      this.validated = null;
      this.cardError = null;
      if (event.error) {
        this.cardError = event.error.message;
        this.validated = false;
      }
    };

    this.card = this.elements.create('card', {
      style: style
    });
    this.card.mount('#card-element');
    this.card.addEventListener('change', eventListener);
  }
}
</script>
<style lang="scss">

.StripeElement {
  border: 1px solid;
  padding: 10px;
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}
</style>
